import React from 'react';
import '../../scss/ResponsibilityView.scss';

export const ResponsibilityView = ({jsonData}) => (
	<table className="ResponsibilityView">
			<thead>
			<tr>
				<th className="Header" colSpan="3">
						{jsonData.head.departmentName}
				</th>
			</tr>
			</thead>
			<tbody>
					<tr>
						<td className="Label">Verantwortlicher</td>
						<td className="Value">{jsonData.head.firstName} {jsonData.head.lastName}</td>
					</tr>
					<tr>
						<td className="Label">Stellvertreter</td>
						<td className="Value">{jsonData.sub.firstName} {jsonData.sub.lastName}</td>
					</tr>
		</tbody>
	</table>
)



// WEBPACK FOOTER //
// ./src/components/ResponsibilityView/index.js